import { render, staticRenderFns } from "./ModalEditarFactura.vue?vue&type=template&id=2c3575fc&scoped=true"
import script from "./ModalEditarFactura.vue?vue&type=script&lang=js"
export * from "./ModalEditarFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3575fc",
  null
  
)

export default component.exports